import { routes } from '@/App/routes';
import { LeftSide, RightSide } from '@/App/Trader/components/TraderModals/SuccessTraderModal/Shared';
import { selectPredeliverTrade } from '@/store/state/predeliver/predeliver.selectors';
import { formChangeAction, resetAction } from '@/store/state/rfs/rfs.actions';
import { selectRfs } from '@/store/state/rfs/rfs.selectors';
import { useAppDispatch } from '@/store/store';
import { toUtc } from '@/utils/dates';
import { DATE_FULL_FORMAT, useFormattingContext } from '@/utils/format';
import { formatDateLocalized } from '@/utils/locale';
import { isDefined } from '@sgme/fp';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

const AmericanForwardSuccessModal = () => {
  const rfs = useSelector(selectRfs);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const predeliverTrade = useSelector(selectPredeliverTrade);
  const { formatAmountWithPrecision } = useFormattingContext();

  const date = isDefined(rfs.date) ? formatDateLocalized(toUtc(new Date(rfs.date)), DATE_FULL_FORMAT) : null;
  const usedAmount = rfs.masterAmount === 'sellAmount' ? rfs.sellAmount : rfs.buyAmount;
  const usedCurrency = rfs.masterAmount === 'sellAmount' ? rfs.sellCurrency : rfs.buyCurrency;

  const isOpen = rfs.isAmericanForwardEmailSent;

  const counterValue = formatAmountWithPrecision(rfs.buyAmount / predeliverTrade?.strike!, 2);

  return (
    <Modal isOpen={isOpen} style={{ maxWidth: '500px' }} className="SuccessTraderModal">
      <div className="pb-3 flex-column modal-header">
        <h5 className="modal-title display-3">
          <i className="icon icon-xs">check</i>
          <span>
            <FormattedMessage id="trader.successModal.predeliver.americanForward.title" />
          </span>
        </h5>
        <span className="text-secondary mt-1">
          <FormattedMessage id="trader.successModal.predeliverInfo.americanForward" />
        </span>
      </div>

      <ModalBody>
        <LeftSide>
          <FormattedMessage id="trader.successModal.operation.americanForward" />
        </LeftSide>
        <RightSide>
          <FormattedMessage id={`trader.successModal.${rfs.masterAmount === 'sellAmount' ? 'sell' : 'buy'}`} />
          &nbsp;
          <span data-e2e={`${rfs.masterAmount === 'sellAmount' ? 'sell' : 'buy'}-amount`}>{formatAmountWithPrecision(usedAmount, 2)}</span>&nbsp;
          <span data-e2e={`${rfs.masterAmount === 'sellAmount' ? 'sell' : 'buy'}-currency`}>{usedCurrency}</span>
        </RightSide>

        <LeftSide>
          <FormattedMessage id="trader.successModal.productDetails.americanForwardRate" />
        </LeftSide>
        <RightSide>{predeliverTrade?.strike}</RightSide>
        <LeftSide>
          <FormattedMessage id="trader.successModal.contramount" />
        </LeftSide>

        <RightSide>
          <FormattedMessage id={`trader.successModal.${rfs.masterAmount === 'sellAmount' ? 'buy' : 'sell'}`} />
          &nbsp;
          <span data-e2e={`${rfs.masterAmount === 'sellAmount' ? 'buy' : 'sell'}-amount`}>{counterValue}</span>
          <span data-e2e={`${rfs.masterAmount === 'sellAmount' ? 'buy' : 'sell'}-currency`}> {rfs.masterAmount === 'sellAmount' ? rfs.buyCurrency : rfs.sellCurrency}</span>
        </RightSide>

        <LeftSide>
          <FormattedMessage id="trader.successModal.productDetails.spotDate" />
        </LeftSide>
        <RightSide dataE2E="callabilityStart-date">{date}</RightSide>
      </ModalBody>

      <ModalFooter className="text-end">
        <button
          type="button"
          className="btn btn-lg btn-default"
          onClick={() => {
            dispatch(formChangeAction({ isAmericanForwardEmailSent: false }));

            dispatch(resetAction());
            navigate(routes.PORTFOLIO);
          }}
        >
          {<FormattedMessage id="trader.successModal.goToOperations" />}
        </button>
        <button
          type="button"
          className="btn btn-lg btn-success btn-default"
          onClick={() => {
            dispatch(formChangeAction({ isAmericanForwardEmailSent: false }));
          }}
        >
          {<FormattedMessage id="trader.successModal.close" />}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AmericanForwardSuccessModal;
